import { render, staticRenderFns } from "./SingleSeat.vue?vue&type=template&id=1c8d9814&scoped=true&"
import script from "./SingleSeat.vue?vue&type=script&lang=js&"
export * from "./SingleSeat.vue?vue&type=script&lang=js&"
import style0 from "./SingleSeat.vue?vue&type=style&index=0&id=1c8d9814&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8d9814",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VFlex,VLayout})
